import axios from 'axios';
import { bus } from '@/main';
import moment from 'moment';
import root from '@/_helpers/roots';
/*eslint-disable */
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery');
let checkMetadataOfPaperApiUrl = root.checkMetadataOfPaperApiUrl.link;

export default {
  name: 'paper-required-fields-update-for-citation-popup',
  components: {
  },
  props: ['paperIdOfCitation'],
  data () {
    return {
      isSubmitted:false,
      author:'',
      journal:'',
      topic:'',
      page_no:'',
      volume:'',
      publisher:'',
      number:'',
      isSubmitted:false,
      citationData:null,
      yearList:[
        1950,
    1951,
    1952,
    1953,
    1954,
    1955,
    1956,
    1957,
    1958,
    1959,
    1960,
    1961,
    1962,
    1963,
    1964,
    1965,
    1966,
    1967,
    1968,
    1969,
    1970,
    1971,
    1972,
    1973,
    1974,
    1975,
    1976,
    1977,
    1978,
    1979,
    1980,
    1981,
    1982,
    1983,
    1984,
    1985,
    1986,
    1987,
    1988,
    1989,
    1990,
    1991,
    1992,
    1993,
    1994,
    1995,
    1996,
    1997,
    1998,
    1999,
    2000,
    2001,
    2002,
    2003,
    2004,
    2005,
    2006,
    2007,
    2008,
    2009,
    2010,
    2011,
    2012,
    2013,
    2014,
    2015,
    2016,
    2017,
    2018,
    2019,
    2020,
    2021,
    2022,
    2023
    ]
    }
  },
  computed: {

  },
  mounted () {
    axios.get(checkMetadataOfPaperApiUrl + '?paper_id=' + this.paperIdOfCitation).then((res) => {
      this.citationData = res.data.data
      this.topic = this.citationData.title || ''
      this.author = this.citationData.author || ''
      this.journal = this.citationData.journal || ''
      this.volume = this.citationData.volume || ''
      this.page_no = this.citationData.pages || ''
      this.publisher = this.citationData.year || ''
      this.number = this.citationData.number || ''
    })
  },
  methods: {
    getPaperPileListAgain(){
      this.$store.dispatch('getAllPaperPileFun')
    },
    updatePaperpileBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.isSubmitted = true
          let payload = {
            title: this.topic,
            author:this.author,
            journal:this.journal,
            volume:this.volume,
            pages:this.page_no,
            year:this.publisher,
            id:this.paperIdOfCitation,
            number:this.number
          }
          axios.post(checkMetadataOfPaperApiUrl, payload)
            .then((res) => {  
              toast.success(res.data.msg || "Request processed successfully.");
              this.isSubmitted = false
              this.closeCreatePaperpilePopup();
              this.getPaperPileListAgain();
            }).catch((err) => {
              this.isSubmitted = false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    closeCreatePaperpilePopup(){
      bus.$emit('paperCitationPopupStateBus', false);
      document.body.classList.remove('body_right_scroll_remove')
    },
  }
}